function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.352",
  height: "22.352"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3351",
  "data-name": "Rectangle 3351",
  fill: "#FF0",
  d: "M0 0h22.352v22.352H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_7103",
  "data-name": "Group 7103",
  clipPath: "url(#clip-path)",
  fill: "#FF0"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4241",
  "data-name": "Path 4241",
  d: "M11.176 0a11.176 11.176 0 1011.176 11.176A11.189 11.189 0 0011.176 0m0 20.051a8.875 8.875 0 118.875-8.875 8.885 8.885 0 01-8.875 8.875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4242",
  "data-name": "Path 4242",
  d: "M9.063 13.1l-2.277-2.274-1.769 1.767 4.045 4.045 8.271-8.271L15.566 6.6z"
}))));